import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

import axios from 'axios';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Container, Typography, Box } from '@mui/material';

import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const StyledBox = styled(Box)({
  '& .ck-content': {
    height: '400px',
  },
});

const StyledButton = styled(Button)({
  padding: '1rem 4rem',
});

export default function WriteCommunity({ parentFunction, boardID, fetchData, data }) {
  // 게시글 form
  const [boardTitle, setBoardTitle] = useState('');
  const [board, setBoard] = useState(' ');
  const { register, handleSubmit } = useForm();
  const [boardType, setBoardType] = React.useState('');

  const typeChange = (event) => {
    setBoardType(event.target.value);
  };

  const onSubmit = () => console.log(board);

  const onWriteHandle = (event, editor) => {
    const data = editor.getData();
    // console.log(data);
    setBoard(data);
  };

  const onTitleWriteHandle = (e) => {
    setBoardTitle(e.target.value);
    // console.log( { event, editor, data } );
  };

  // ---------------------------------------------------------

  const [write, setWrite] = useState(false);

  function sendCancel() {
    parentFunction();
  }

  // const sendData = {
  //     board_id : boardID,
  //     user_token : "8eaa0410-8be2-11ed-a0d7-8141ffd77712",
  //     content_title : boardTitle,
  //     content_detail : board,
  //     file_upload : 0
  //   }

  const insertContent = async () => {
    if (sessionStorage.getItem('login_info') !== null && board !== null && boardTitle !== null) {
      const sendData = {
        board_id: boardID,
        user_token: JSON.parse(sessionStorage.getItem('login_info')).user_token,
        content_title: boardTitle,
        content_detail: board,
        file_upload: 0,
      };

      try {
        const response = await axios({
          url: `${process.env.REACT_APP_SERVER_URL}/boards/create`,
          method: 'post',
          data: sendData,
        });

        console.log('data', response.data[0][0]);
        fetchData(data);
        sendCancel();
      } catch (error) {
        console.log('error', error);
      }
    }
  };

  return (
    <>
      <StyledBox sx={{ padding: '60px 10%' }}>
        <h2>글쓰기</h2>

        <FormControl fullWidth style={{ margin: '40px 0 20px 0' }}>
          <TextField
            id="standard-basic"
            label="제목"
            variant="outlined"
            onKeyUp={onTitleWriteHandle}
            placeholder="제목을 입력하세요"
          />
        </FormControl>

        <CKEditor
          editor={ClassicEditor}
          data=""
          onReady={(editor) => {
            // You can store the "editor" and use when it is needed.
            console.log('Editor is ready to use!', editor);
          }}
          onChange={onWriteHandle}
          // onBlur={ ( event, editor ) => {
          //     console.log( 'Blur.', editor );
          // } }
          // onFocus={ ( event, editor ) => {
          //     console.log( 'Focus.', editor );
          // } }
        />

        <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'flex-end' }}>
          <StyledButton variant="contained" onClick={insertContent} style={{ marginRight: '10px' }}>
            글쓰기
          </StyledButton>
          <StyledButton
            variant="outlined"
            onClick={() => {
              sendCancel();
            }}
          >
            취소
          </StyledButton>
        </div>
      </StyledBox>
    </>
  );
}
